"use strict";
// The Control with decorations
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.renderAutocompleteControl = void 0;
var solid_logic_1 = require("solid-logic");
var solid_ui_1 = require("solid-ui");
var autocompletePicker_1 = require("./autocompletePicker"); // dbpediaParameters
var publicData_1 = require("./publicData");
var WEBID_NOUN = 'Solid ID';
var kb = solid_logic_1.store;
var AUTOCOMPLETE_THRESHOLD = 4; // don't check until this many characters typed
var AUTOCOMPLETE_ROWS = 12; // 20?
var GREEN_PLUS = solid_ui_1.icons.iconBase + 'noun_34653_green.svg';
var SEARCH_ICON = solid_ui_1.icons.iconBase + 'noun_Search_875351.svg';
function renderAutocompleteControl(dom, person, options, addOneIdAndRefresh) {
    return __awaiter(this, void 0, void 0, function () {
        function autoCompleteDone(object, _name) {
            return __awaiter(this, void 0, void 0, function () {
                var webid;
                return __generator(this, function (_a) {
                    webid = object.uri;
                    removeDecorated();
                    return [2 /*return*/, addOneIdAndRefresh(person, webid)];
                });
            });
        }
        function greenButtonHandler(_event) {
            return __awaiter(this, void 0, void 0, function () {
                var webid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, solid_ui_1.widgets.askName(dom, solid_logic_1.store, creationArea, solid_ui_1.ns.vcard('url'), null, WEBID_NOUN)];
                        case 1:
                            webid = _a.sent();
                            if (!webid) {
                                return [2 /*return*/]; // cancelled by user
                            }
                            return [2 /*return*/, addOneIdAndRefresh(person, webid)];
                    }
                });
            });
        }
        function removeDecorated() {
            creationArea.removeChild(decoratedAutocomplete);
            decoratedAutocomplete = null;
        }
        function searchButtonHandler(_event) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!decoratedAutocomplete) return [3 /*break*/, 1];
                            creationArea.removeChild(decoratedAutocomplete);
                            decoratedAutocomplete = null;
                            return [3 /*break*/, 3];
                        case 1:
                            decoratedAutocomplete = dom.createElement('div');
                            decoratedAutocomplete.setAttribute('style', 'display: flex; flex-flow: wrap;');
                            _b = (_a = decoratedAutocomplete).appendChild;
                            return [4 /*yield*/, (0, autocompletePicker_1.renderAutoComplete)(dom, acOptions, autoCompleteDone)];
                        case 2:
                            _b.apply(_a, [_c.sent()]);
                            decoratedAutocomplete.appendChild(acceptButton);
                            decoratedAutocomplete.appendChild(cancelButton);
                            creationArea.appendChild(decoratedAutocomplete);
                            _c.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function droppedURIHandler(uris) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, uris_1, webid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _i = 0, uris_1 = uris;
                            _a.label = 1;
                        case 1:
                            if (!(_i < uris_1.length)) return [3 /*break*/, 4];
                            webid = uris_1[_i];
                            return [4 /*yield*/, addOneIdAndRefresh(person, webid)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        var queryParams, acceptButton, cancelButton, klass, acOptions, decoratedAutocomplete, creationArea, plus;
        return __generator(this, function (_a) {
            queryParams = options.queryParameters || publicData_1.wikidataParameters;
            acceptButton = solid_ui_1.widgets.continueButton(dom);
            cancelButton = solid_ui_1.widgets.cancelButton(dom, removeDecorated);
            klass = options["class"];
            acOptions = {
                queryParams: queryParams,
                "class": klass,
                acceptButton: acceptButton,
                cancelButton: cancelButton
            };
            decoratedAutocomplete = null;
            // const { dom } = dataBrowserContext
            options = options || {};
            options.editable = kb.updater.editable(person.doc().uri, kb);
            creationArea = dom.createElement('div');
            creationArea.setAttribute('style', 'display: flex; flex-flow: wrap;');
            if (options.editable) {
                // creationArea.appendChild(await renderAutoComplete(dom, options, autoCompleteDone)) wait for searchButton
                creationArea.style.width = '100%';
                plus = creationArea.appendChild(solid_ui_1.widgets.button(dom, GREEN_PLUS, options.idNoun, greenButtonHandler));
                solid_ui_1.widgets.makeDropTarget(plus, droppedURIHandler, null);
                if (options.dbLookup) {
                    creationArea.appendChild(solid_ui_1.widgets.button(dom, SEARCH_ICON, options.idNoun, searchButtonHandler));
                }
            }
            return [2 /*return*/, creationArea];
        });
    });
} // renderAutocompleteControl
exports.renderAutocompleteControl = renderAutocompleteControl;
// ends
